<div class="px-6 py-4 border-b border-gray-100 bg-white flex flex-row justify-between items-center gap-4">
  <div class="flex items-center gap-3">
    <span class="h-10 w-10 rounded-xl bg-rose-50 text-rose-600 flex items-center justify-center flex-shrink-0"><mat-icon>delete_forever</mat-icon></span>
    <div>
      <h1 class="text-xl font-bold text-gray-900 leading-tight">Log scrap</h1>
      <p class="text-xs text-gray-500">Writes the stock off at the chosen yard straight away</p>
    </div>
  </div>
  <button type="button" (click)="dialogRef.close({ status: false })" class="h-9 w-9 rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-800 flex items-center justify-center text-sm transition-colors flex-shrink-0" aria-label="Close" matTooltip="Close dialog">✕</button>
</div>

<mat-dialog-content class="mat-typography !px-6 !py-5 !max-h-[68vh]">

  <div class="relative">
    <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Product *</label>
    <app-product-picker
      class="mt-2"
      placeholder="Search by product name, SKU or barcode"
      [products]="products"
      [variantOnly]="true"
      [selectedId]="selectedProduct?.productId ?? null"
      [(query)]="productSearchTerm"
      (queryEdited)="onProductSearchInput()"
      (picked)="selectProduct($event)"
    />
    @if (selectedProduct) {
    <div class="mt-2 text-xs" [class]="overStock ? 'text-red-600 font-semibold' : 'text-gray-500'">
      Available at {{ warehouse }}: {{ availableStock ?? '-' }}@if (overStock) { - not enough in stock }
    </div>
    }
  </div>

  <div class="grid grid-cols-2 gap-x-4 mt-4">
    <div>
      <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Quantity *</label>
      <input type="number" min="1"
        class="mt-2 w-full px-3 py-2.5 rounded-xl border outline-none transition-all text-sm"
        [class]="overStock ? 'border-red-400 ring-4 ring-red-100 bg-white' : 'border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100'"
        [(ngModel)]="quantity" />
    </div>
    <div>
      <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Yard *</label>
      <select class="mt-2 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 outline-none text-sm" [(ngModel)]="warehouse">
        @for (w of warehouseOptions; track w) { <option [value]="w">{{ w }}</option> }
      </select>
    </div>
  </div>

  <div class="mt-4">
    <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Reason *</label>
    <div class="mt-2 grid grid-cols-2 sm:grid-cols-3 gap-2">
      @for (r of reasonOptions; track r.value) {
      <button type="button" class="flex items-center gap-2 px-3 py-2.5 rounded-xl border text-xs font-semibold transition-all"
        [class]="reason === r.value ? 'bg-neutral-900 text-white border-neutral-900 shadow-sm' : 'bg-white text-gray-600 border-gray-200 hover:border-amber-300 hover:bg-amber-50'"
        (click)="reason = r.value">
        <mat-icon class="!text-[16px] !h-4 !w-4" [class]="reason === r.value ? '!text-amber-400' : '!text-gray-400'">{{ r.icon }}</mat-icon>{{ r.label }}
      </button>
      }
    </div>
  </div>

  <div class="mt-4">
    <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Notes</label>
    <input type="text" placeholder="Optional notes"
      class="mt-2 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm"
      [(ngModel)]="notes" />
  </div>
</mat-dialog-content>

<div class="px-6 py-4 border-t border-gray-100 bg-white flex flex-row items-center justify-end gap-3">
  <button type="button" (click)="dialogRef.close({ status: false })" class="px-5 py-2.5 rounded-xl border border-gray-200 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors">Cancel</button>
  <button type="button" [disabled]="submitting" (click)="onSubmit()"
    class="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 font-bold text-sm shadow-md shadow-amber-200 hover:from-amber-300 hover:to-amber-400 active:scale-[0.98] transition-all disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none">
    @if (submitting) { <span class="inline-block h-4 w-4 rounded-full border-2 border-neutral-900 border-t-transparent animate-spin"></span> }
    Log scrap
  </button>
</div>
